import React from 'react';
import TaskTypes from '../../resources/enums/TaskTypes';

import EnterTheAnswer from './TaskTypes/EnterTheAnswer';
import Images from './TaskTypes/Images';
import OnlyDescription from './TaskTypes/OnlyDescription';
import Plates from './TaskTypes/Plates';
import Collage from './TaskTypes/Collage';
import QuestionAndAnswers from './TaskTypes/QuestionAndAnswers';
import { TaskTypeProps } from './types';
import { getTaskTypeById } from './actions';
import Milestone from './TaskTypes/Milestone';
import Video from './TaskTypes/Video';

const availableTypes = (props: TaskTypeProps) => {
    return {
        [TaskTypes.Plates]: <Plates {...props} />,
        [TaskTypes.EnterTheAnswer]: <EnterTheAnswer {...props} />,
        [TaskTypes.OnlyDescription]: <OnlyDescription {...props} />,
        [TaskTypes.Images]: <Images {...props} />,
        [TaskTypes.Collage]: <Collage {...props} />,
        [TaskTypes.QuestionAndAnswers]: <QuestionAndAnswers {...props} />,
        [TaskTypes.Milestone]: <Milestone {...props} />,
        [TaskTypes.Video]: <Video {...props} />,
    } as Record<string, JSX.Element>;
};

export const getInstance = (id: string, props: TaskTypeProps) => {
    const taskType = getTaskTypeById(id, props.taskTypes);
    if (!taskType) return;
    return availableTypes(props)[taskType.type];
};
